export default "__VITE_ASSET__Ds_9O8pS__"